// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"6f527bc5","157":"6f527bc5","302":"6f527bc5","875":"6f527bc5","926":"6f527bc5"}[chunkId] + ".chunk.css";
};